import { render } from "./headerTitle.vue?vue&type=template&id=daa4d128&scoped=true"
import script from "./headerTitle.vue?vue&type=script&lang=js"
export * from "./headerTitle.vue?vue&type=script&lang=js"

import "./headerTitle.vue?vue&type=style&index=0&id=daa4d128&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daa4d128"]])

export default __exports__